export type sliderItem = {
  to: string;
  name: string;
  type: string;
};

const sliderItemsData: sliderItem[] = [
  { to: '/mobilnye-telefony/', name: 'Телефоны', type: 'smartphone' },
  { to: '/noutbuki/', name: 'Ноутбуки', type: 'laptops' },
  { to: '/televizory/', name: 'Телевизоры', type: 'tv' },
  { to: '/planshety/', name: 'Планшеты', type: 'tab' },
  { to: '/parfyumeriya/', name: 'Парфюмерия', type: 'parfum' },
  {
    to: '/kofevarki-i-kofemashiny/',
    name: 'Кофемашины',
    type: 'coffe',
  },
  { to: '/videokarty/', name: 'Видеокарты', type: 'video' },
  {
    to: '/feny-pribory-dlya-ukladki-volos/',
    name: 'Фены',
    type: 'air',
  },
  {
    to: '/smart-chasy-i-umnye-braslety/',
    name: 'Смарт-часы',
    type: 'smartwatch',
  },
  {
    to: '/feny-pribory-dlya-ukladki-volos/',
    name: 'Приборы для укладки',
    type: 'devicesLaying',
  },
  {
    to: '/sredstva-po-uhodu-za-telom/',
    name: 'Уход за лицом и телом',
    type: 'facial',
  },
  {
    to: '/zhivye-cvety/',
    name: 'Цветы',
    type: 'flowers',
  },
  {
    to: '/sredstva-po-uhodu-za-telom/',
    name: 'Средство ухода за лицом',
    type: 'facial2',
  },

  { to: '/naushniki/', name: 'Наушники и гарнитура', type: 'pods' },
  { to: '/begovye-dorozhki/', name: 'Беговые дорожки', type: 'run' },
  {
    to: '/bytovye-holodilniki-morozilniki/',
    name: 'Холодильники',
    type: 'fringe',
  },
  { to: '/elektrochayniki-termopoty/', name: 'Чайники', type: 'chai' },
  { to: '/parovarki-multivarki/', name: 'Мультиварки', type: 'multy' },
  { to: '/myasorubki/', name: 'Mясорубки', type: 'mincer' },
  { to: '/miksery/', name: 'Миксеры', type: 'mixer' },
  { to: '/pylesosy/', name: 'Пылесосы', type: 'vacum' },
  { to: '/muzhskie-elektrobritvy/', name: 'Бритвы', type: 'trimer' },
  {
    to: '/vinilovye-proigryvateli/',
    name: 'Виниловые проигрыватели',
    type: 'vinil',
  },
  {
    to: '/tehnika-dlya-krasoty-i-zdorovya/',
    name: 'Техника для красоты и здоровья',
    type: 'health',
  },
  {
    to: '/ellipticheskie-trenazhery/',
    name: 'Эллипсоиды',
    type: 'ellips',
  },
  {
    to: '/sredstva-po-uhodu-za-telom/balzamy-dlya-gub-eat-my/',
    name: 'Бальзамы для губ',
    type: 'lipBalms',
  },
  {
    to: '/zhenskie-tufli/',
    name: 'Туфли',
    type: 'shoes',
  },
  {
    to: '/chehly-dlya-telefonov-planshetov-actionkamer/',
    name: 'Чехлы',
    type: 'covers',
  },
  {
    to: '/elektricheskie-zubnye-schetki-zubnye-centry/',
    name: 'Электрические зубные щетки',
    type: 'elToothbrushes',
  },
  {
    to: '/tovary-dlya-fitnesa-aerobiki-pilatesa-yogi/kovrik-dlya-fitnesa/',
    name: 'Коврики для фитнеса',
    type: 'fitnessMats',
  },
  {
    to: '/makiyazh-dekorativnaya-kosmetika/',
    name: 'Макияж',
    type: 'makeup',
  },
  {
    to: '/laki-dlya-nogtei/',
    name: 'Для ногтей',
    type: 'forNails',
  },
  {
    to: '/kosmetika-dlya-volos/',
    name: 'Уход за волосами',
    type: 'hairCare',
  },
  {
    to: '/ukladka-i-stailing/',
    name: 'Укладка и стайлинг',
    type: 'laying',
  },
  {
    to: '/kolonki-i-akusticheskie-sistemy/jbl/',
    name: 'Колонки',
    type: 'columns',
  },
  {
    to: '/bokaly-fuzhery/',
    name: 'Бокалы и фужеры',
    type: 'glasses',
  },
  {
    to: '/skaterti-i-salfetki/set-of-napkins/',
    name: 'Полотенца',
    type: 'towels',
  },
  {
    to: '/tovary-dlya-fitnesa-aerobiki-pilatesa-yogi/kolco-dlya-pilatesa/',
    name: 'Кольца для пилатеса',
    type: 'pilatesRings',
  },
  { to: '/kukly-i-aksessuary/', name: 'Куклы', type: 'dolls' },
  { to: '/nastolnye-igry/', name: 'Настольные игры', type: 'tableGames' },
  { to: '/myagkie-igrushki/', name: 'Мягкие игрушки', type: 'softToys' },
  {
    to: '/kraski-dlya-risovaniya/',
    name: 'Краски для рисования',
    type: 'forDrawing',
  },
  {
    to: '/detskye-samokaty/trehkolesnye-samokaty/',
    name: 'Самокаты',
    type: 'scooters',
  },
  {
    to: '/tovary-dlya-tvorchestva-hobbi/opyty-i-eksperimenty/',
    name: 'Наборы для творчества и экспериментов',
    type: 'setsCreativity',
  },
  {
    to: '/detskaya-dekorativnaya-kosmetika/',
    name: 'Декоративная косметика',
    type: 'decorativeCosmetics',
  },
  {
    to: '/tovary-dlya-tvorchestva-hobbi/nabory-dlya-risovaniya/',
    name: 'Наборы для рисования',
    type: 'drawingKits',
  },
  {
    to: '/pribory-dlya-ukhoda-za-litsom-telom/',
    name: 'Приборы для ухода за лицом и телом',
    type: 'faceInstruments',
  },
];

export default sliderItemsData;
